import Slider from "react-slick";
import styles from "./HomeServicesCarousel.module.css";
import engineIcon from "../../assets/icons/engine.svg";
import electricIcon from "../../assets/icons/electric.svg";
import airConditioningIcon from "../../assets/icons/airconditioning.svg";
import { useNavigate } from "react-router-dom";

// Import slick-carousel CSS
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ecoFriendlyIcon from "../../assets/icons/eco.svg";

export const HomeServicesCarousel = () => {
  // Use the hook directly inside the component
  const navigate = useNavigate();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
  };

  // A dedicated handler makes the JSX cleaner
  const handleLearnMoreClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className={styles.slideContainer}>
      <Slider {...settings}>
        <div key="engine-service">
          <div className={styles.serviceCard}>
            <img src={engineIcon} alt="engine" className={styles.icon} />
            <h3>Engine Diagnostics</h3>
            <p>
              From our signature hydrogen cleaning to light mechanical repairs,
              we keep your engine running smoothly.
            </p>
            <button
              onClick={() => handleLearnMoreClick("/about")}
              className={styles.serviceLearnMore}
            >
              Learn More
            </button>
          </div>
        </div>
        <div key="engine-service">
          <div className={styles.serviceCard}>
            <img
              src={ecoFriendlyIcon}
              alt="Eco-Friendly"
              className={styles.icon}
            />
            <h3>Carbon Removal</h3>
            <p>
              Remove harmful deposits, reduce friction, enhance power and
              acceleration by using our active hydrogen cleaning system
            </p>
            <button
              onClick={() => handleLearnMoreClick("/about")}
              className={styles.serviceLearnMore}
            >
              Learn More
            </button>
          </div>
        </div>
        <div key="electrical-service">
          <div className={styles.serviceCard}>
            <img src={electricIcon} alt="electrical" className={styles.icon} />
            <h3>Electrical Services</h3>
            <p>
              Certified auto electricians diagnose and repair all vehicle
              electrical systems, from batteries to complex wiring.
            </p>
            <button
              onClick={() => handleLearnMoreClick("/about")} // Example path
              className={styles.serviceLearnMore}
            >
              Learn More
            </button>
          </div>
        </div>

        <div key="ac-service">
          <div className={styles.serviceCard}>
            <img
              src={airConditioningIcon}
              alt="air conditioning"
              className={styles.icon}
            />
            <h3>Air Conditioning</h3>
            <p>
              Stay comfortable with our comprehensive A/C services, including
              diagnostics, recharging, and repairs.
            </p>
            <button
              onClick={() => handleLearnMoreClick("/about")}
              className={styles.serviceLearnMore}
            >
              Learn More
            </button>
          </div>
        </div>
      </Slider>
    </div>
  );
};
